export enum RiskMatrixInstance {
  LossPotential = 1,
  ResidualLossPotential = 2
}

export enum CopyRiskEvaluationInstance {
  CopyPrevious = 1,
  CopyPreviousFromOtherInstance = 2
}

